import React from 'react';

const TrackCompletion = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={154}
    height={142}
    viewBox="0 0 128 119">
    <g fill="none" fillRule="evenodd" transform="translate(1 1)">
      <circle
        cx="58.5"
        cy="58.5"
        r="58.5"
        stroke="#ED6347"
        strokeOpacity=".3"
        strokeWidth={2}
      />
      <g transform="translate(94 17)">
        <circle cx="16.5" cy="16.5" r="16.5" fill="#ED6347" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M16.5 15.4l5.1-5.2a.8.8 0 0 1 1.2 1.2l-5.2 5.1 5.2 5.1a.8.8 0 0 1-1.2 1.2l-5.1-5.2-5.1 5.2a.8.8 0 0 1-1.2-1.2l5.2-5.1-5.2-5.1a.8.8 0 0 1 1.2-1.2l5.1 5.2z"
        />
      </g>
      <path
        fill="#F9CFC6"
        fillRule="nonzero"
        d="M73.7 44.9v-.1c0-.4-.1-.7-.4-1a1 1 0 0 0-.7-.3h-5.2v-.2a104.2 104.2 0 0 1 0-1.3c0-.4-.1-.7-.4-1a1 1 0 0 0-.7-.3H63v-.2c0-1 0-1.9-.2-2.7 0-.5-.6-.8-1-.8H57a1 1 0 0 0-.8.4c-.2.3-.3.7-.2 1v.2l-.1.4v1.6h-.2l-3-.1h-.4c-.6 0-1.2.4-1.2 1.2V43h-.3c-1.7 0-3.5 0-5.3.2h-.2c-.6 0-1.2.4-1.2 1.2v4.4c0 .3 0 .5.2.7v.1a623.8 623.8 0 0 1-.4 28.5v.1c0 .4 0 .6.2.8.1.2.3.3.6.4 9 1.3 18 1.4 27.8 1.4.7 0 1-.5 1-.8.2-.2.3-.5.3-.8V45.6c0-.2 0-.5-.2-.7zm-15.5-5.6H61v1.4h-2.7v-1.4zM53.1 48a63 63 0 0 0 .3-4.8v-.2h.2L65 43h.3v.2l.1 5v.2h-.2l-6.2-.2-5.6-.2H53V48zm18.6 30.7h-.2c-8.9 0-16.9-.1-25-1.2h-.2V77a659.4 659.4 0 0 0 .2-28.8v-2.7h.2c1.4-.2 2.9-.2 4-.2h.2v.3a37.5 37.5 0 0 0 0 3.1v.1c-.1.4 0 .8.2 1.1.2.2.5.4.8.4a369.9 369.9 0 0 0 14.2.5c.4 0 .6-.2.7-.3l.5-.5v-.2l.1-.2c.2-.2.3-.5.2-.7a33.5 33.5 0 0 1 0-2.9V46h4.1v32.7z"
      />
      <rect width={13} height={1} x="52.5" y="59.5" stroke="#F9CFC6" rx=".5" />
      <rect width={13} height={1} x="52.5" y="63.5" stroke="#F9CFC6" rx=".5" />
      <rect width={13} height={1} x="52.5" y="67.5" stroke="#F9CFC6" rx=".5" />
    </g>
  </svg>
);

export default TrackCompletion;
